import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import useGenerateInvoicePdf from "./useGenerateInvoicePdf";
import usePrepareGenerateInvoicePdf from "./usePrepareGenerateInvoicePdf";
import { GenerateInvoicePdfActionContext } from "./GenerateInvoicePdfActionContext";
import { Form } from "react-bootstrap";

function useGenerateInvoicePdfAction(modelConfig: any, index: any): any {
  const prepare = usePrepareGenerateInvoicePdf();
  const prepareFunction = (invoiceId: any) => prepare(invoiceId);

  const onSuccess = () => {
    setShowModal(false);
    index();
  };

  const run = useGenerateInvoicePdf();
  const runFunction = (invoiceId: any) => run(invoiceId, onSuccess);

  const contextInstance = useContext(GenerateInvoicePdfActionContext);
  const { setShowModal, invoiceId, sendToCustomer, setSendToCustomer } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "generate-invoice-pdf",
  onSubmit: () => invoiceId != null && runFunction(invoiceId),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <div>
        <p>{t("are_you_sure_you_want_to_generate_the_invoice_pdf_for_this_booking?")}</p>
        <Form.Group className="mt-3">
          <Form.Check 
            type="checkbox"
            id="send-to-customer-checkbox"
            label={t("send_to_customer")}
            checked={sendToCustomer}
            onChange={(e) => setSendToCustomer(e.target.checked)}
          />
        </Form.Group>
      </div>
    </CrudModuleFactoryModal>
  );

  return {
    prepareGenerateInvoicePdfFunction: prepareFunction,
    actionTemplate,
  };
}

export default useGenerateInvoicePdfAction;
